import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import styles from './SingleSelectMenu.scss.js';

const SingleSelectMenu = _ref => {
  let {
    isOpen,
    isGrid = false,
    hideInnerBorder = false,
    options,
    onSelect,
    maxHeightValue,
    hideOuterBorder = false
  } = _ref;
  const buildMenuList = () => options.map(_ref2 => {
    let {
      type,
      content
    } = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames(styles['options-item'], {
        [styles['options-item--hide-inner-border']]: hideInnerBorder
      }),
      key: type
    }, /*#__PURE__*/React.createElement("button", {
      className: styles['options-item-button'],
      onClick: () => onSelect(type)
    }, content));
  });
  const optionStyles = {
    maxHeight: maxHeightValue || 'none',
    overflowY: maxHeightValue ? 'auto' : 'visible'
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: isOpen,
    timeout: 250,
    unmountOnExit: true,
    classNames: {
      enter: styles.enter,
      enterActive: styles['enter-active'],
      exit: styles.exit,
      exitActive: styles['exit-active']
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, {
      [styles['wrapper--grid']]: isGrid,
      [styles['wrapper--hide-outer-border']]: hideOuterBorder
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.options,
    style: optionStyles
  }, buildMenuList())));
};
var SingleSelectMenu$1 = SingleSelectMenu;

export { SingleSelectMenu$1 as default };
//# sourceMappingURL=SingleSelectMenu.js.map
